/* @flow */
import http from '@shared/ApiFactory'
import { SM_API_PATH } from '@shared/ApiConfig'

export const fetchAISiteInitialData_API = (id: number) => {
  return http.GET(`${SM_API_PATH}/sites/ai/${id}`)
}
